/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { useSelector } from 'react-redux';

import { State } from '../../../../redux';
import { Wrapper, Header, Table } from '../../../../components/common/Pipeline';
import { NotaryAPI } from '../../../../api/notary/types';
import { EmptySection } from '../../../../../src/components/common/EmptySection/EmptySection';
import { contactsColumnConfigurations } from './configs';
import { isEmpty } from '@utils/lodash';

const styles = StyleSheet.create({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 1400,
  },
  headerWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingRight: 40,
  },
  tableWrapper: {
    width: '100%',
    padding: '0 40px',
  },
});

export namespace ContactList {
  export interface Props {
    roomId: string;
    isLoading: boolean;
  }
}

export const ClosingPartyTypeToRoleName: Map<string, string> = new Map([
  [NotaryAPI.ClosingPartyType.SETTLEMENT, 'Settlement Agent'],
  [NotaryAPI.ClosingPartyType.CLOSER, 'Closer'],
]);

export const ContactList: React.FC<ContactList.Props> = ({ isLoading }) => {
  const { roomDetail } = useSelector((state: State) => state);

  const contacts = roomDetail.room?.closingParties as NotaryAPI.ClosingParty[];
  const isContactsEmpty = isEmpty(contacts);

  return (
    <div className={css(styles.wrapper)}>
      <Wrapper>
        <div className={css(styles.headerWrapper)}>
          <Header header="Contacts" />
        </div>
        <div className={css(styles.tableWrapper)}>
          {!isContactsEmpty && (
            <Table data-it="contactsTable" data={contacts} tableColumns={contactsColumnConfigurations} />
          )}
          <EmptySection
            isLoading={isLoading}
            isEmpty={isContactsEmpty}
            emptyMessage="No contact information available at the moment."
          />
        </div>
      </Wrapper>
    </div>
  );
};
